import { map, flatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataService, ApiService, InspectionPluginService, LanguageService } from '../../shared/services/index';
import { InspectionPlugin, Icons } from '../../shared/models/index';
import { CommentPluginFactoryService } from './comment-plugin-factory.plugin';

@Injectable()
export class CommentPluginService extends InspectionPluginService {
  public typeKeys: any = [
    { value: 1, label: 'plugins.comments.technical-service' },
    { value: 2, label: 'plugins.comments.customer' }
  ];

  public importanceKeys: any = [
    { value: 1, label: 'plugins.comment.select-comment-importance-level-1', showIcon: true },
    { value: 2, label: 'plugins.comment.select-comment-importance-level-2', showIcon: false }
  ];

  public types: any = [];
  public importanceLevels: any = [];

  public icons: any = [];
  public iconsKeys: any = [
    { value: null, icon: '', label: 'plugins.comment.general' },
    { value: 1, icon: Icons.importanceIcons[0], label: 'plugins.comment.mecanician' },
    { value: 2, icon: Icons.importanceIcons[1], label: 'plugins.comment.electrician' }
  ];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private language: LanguageService,
    private commentFactory: CommentPluginFactoryService
  ) {
    super(apiService, dataService, null, commentFactory);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe((value) => this.applyTranslations());
  }

  public updateComment(inspectionId: string, pointId: string, pluginId: string, remarks: any): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, remarks).pipe(
      map((res: InspectionPlugin) => {
        for (let i = 0; i < this.icons.length; i++) {
          let icon = Icons.getIconByName(`${Icons.importantIcon}${i + 1}`);
          icon.count = 0;
          this.dataService.processIcons(false, icon, inspectionId, pointId);
        }

        this.dataService.processIcons(
          remarks.some((r) => r.Type === 1 || r.Type === 0),
          Icons.getIconByName(Icons.commentsIconName),
          inspectionId,
          pointId
        );
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  public getTypes() {
    return this.types;
  }

  public getImportanceLevels() {
    return this.importanceLevels;
  }

  public getIcons() {
    return this.icons;
  }

  public deletePlugin(inspectionId: string, pointId: string, pluginId: string) {
    return super.deletePlugin(inspectionId, pointId, pluginId).pipe(
      map((success) => {
        if (success) {
          for (let i = 0; i < this.icons.length; i++) {
            let icon = Icons.getIconByName(`${Icons.importantIcon}${i + 1}`);
            icon.count = 0;
            this.dataService.processIcons(false, icon, inspectionId, pointId);
          }
          this.dataService.processIcons(false, Icons.getIconByName(Icons.commentsIconName), inspectionId, pointId);
        }
        return success;
      })
    );
  }

  public applyTranslations() {
    this.types = [];
    this.importanceLevels = [];
    this.copyTranslationValues(this.typeKeys, this.types, this.language);
    this.copyTranslationValues(this.importanceKeys, this.importanceLevels, this.language);
    this.copyTranslationValues(this.iconsKeys, this.icons, this.language);
  }

  private update(inspectionId: string, pointId: string, pluginId: string, remarks: any): Observable<any> {
    return this.commentFactory.updateComment(inspectionId, pointId, pluginId, remarks, 'Remarks').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
